import React from "react";
import Project from "./projet";

export function ProjectCanceled() {
  return <Project status="Annulé" />;
}